import type { HTMLAttributes } from "react";
import { cx } from "./cx";

export interface SpinnerProps extends HTMLAttributes<HTMLSpanElement> {
  size?: "md" | "lg";
  /** Accessible label; defaults to "Chargement". Set aria-hidden to suppress. */
  label?: string;
}

export function Spinner({ size = "md", label = "Chargement", className, ...rest }: SpinnerProps) {
  const hidden = rest["aria-hidden"];
  return (
    <span
      className={cx("nv-spinner", size === "lg" && "nv-spinner--lg", className)}
      role={hidden ? undefined : "status"}
      aria-label={hidden ? undefined : label}
      {...rest}
    />
  );
}
